<template>
  <el-container class="personal_center personal_center_contestant">
    <div class="breadcrumb m">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/personal_center' }">个人中心</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/personal_center/judge' }"
                            v-if="$route.path.includes('/personal_center/judge')">
          我是评委
        </el-breadcrumb-item>
        <el-breadcrumb-item v-if="$route.path==='/personal_center/judge/opus/list'">作品评审</el-breadcrumb-item>
        <template v-if="$route.path==='/personal_center/judge/opus/detail'">
          <el-breadcrumb-item :to="{ path: '/personal_center/judge/opus/list' }">作品评审</el-breadcrumb-item>
          <el-breadcrumb-item>在线评分</el-breadcrumb-item>
        </template>
        <template v-if="$route.path==='/personal_center/judge/opus/review'">
          <el-breadcrumb-item :to="{ path: '/personal_center/judge/opus/list' }">作品评审</el-breadcrumb-item>
          <el-breadcrumb-item>在线评分</el-breadcrumb-item>
        </template>
        <template v-if="$route.path==='/personal_center/judge/opus/reviewDetail'">
          <el-breadcrumb-item :to="{ path: '/personal_center/judge/opus/list' }">作品评审</el-breadcrumb-item>
          <el-breadcrumb-item>评分详情</el-breadcrumb-item>
        </template>
        <template v-if="$route.path==='/personal_center/judge/opus/scene'">
          <el-breadcrumb-item :to="{ path: '/personal_center/judge/opus/list' }">作品评审</el-breadcrumb-item>
          <el-breadcrumb-item>现场评分</el-breadcrumb-item>
        </template>
        <template v-if="$route.path==='/personal_center/judge/opus/sceneReview'">
          <el-breadcrumb-item :to="{ path: '/personal_center/judge/opus/list' }">作品评审</el-breadcrumb-item>
          <el-breadcrumb-item>现场评分</el-breadcrumb-item>
        </template>
      </el-breadcrumb>
    </div>
    <div class="m">
      <div class="left_box">
        <el-menu
            :default-active="curActive"
            background-color="#fff"
            text-color="#333"
            active-text-color="#2468F2"
        >
          <el-menu-item index="/personal_center/judge/opus/list" @click="toList">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M16.0003 4.16671V13.1667C16.0001 13.3876 15.9122 13.5995 15.756 13.7557C15.5997 13.9119 15.3879 13.9998 15.167 14H1.50033C1.27939 13.9998 1.06757 13.9119 0.911344 13.7557C0.755117 13.5995 0.66724 13.3876 0.666992 13.1667V2.16671C0.66724 1.94577 0.755117 1.73396 0.911344 1.57773C1.06757 1.4215 1.27939 1.33363 1.50033 1.33338H6.12657C6.23606 1.33308 6.34451 1.35449 6.44566 1.39639C6.5468 1.43828 6.63864 1.49982 6.71585 1.57744L8.42293 3.28452C8.43835 3.30007 8.45671 3.31239 8.47693 3.32078C8.49716 3.32916 8.51885 3.33345 8.54074 3.33338H15.167C15.3879 3.33363 15.5997 3.4215 15.756 3.57773C15.9122 3.73396 16.0001 3.94577 16.0003 4.16671ZM11.1045 8.01286C11.0853 7.9537 11.0499 7.90111 11.0023 7.86101C10.9548 7.82092 10.897 7.79493 10.8354 7.78598L9.31282 7.56484L8.63262 6.18588C8.6051 6.13008 8.56252 6.08309 8.50968 6.05024C8.45685 6.01738 8.39587 5.99997 8.33366 5.99997C8.27144 5.99997 8.21047 6.01738 8.15763 6.05024C8.1048 6.08309 8.06222 6.13008 8.0347 6.18588L7.35449 7.56484L5.83262 7.78598C5.77111 7.79493 5.71334 7.8209 5.66581 7.86095C5.61828 7.90101 5.5829 7.95355 5.56366 8.01265C5.54442 8.07175 5.54209 8.13505 5.55692 8.1954C5.57176 8.25576 5.60317 8.31077 5.64762 8.35421L6.74876 9.42713L6.48835 10.9429C6.47784 11.0042 6.48469 11.0672 6.50813 11.1248C6.53157 11.1824 6.57066 11.2323 6.62097 11.2688C6.67129 11.3054 6.73083 11.3271 6.79286 11.3316C6.85489 11.3361 6.91694 11.3231 6.97199 11.2942L8.33366 10.5795L9.6948 11.295C9.74985 11.324 9.8119 11.3369 9.87393 11.3325C9.93596 11.328 9.9955 11.3062 10.0458 11.2697C10.0961 11.2331 10.1352 11.1832 10.1587 11.1256C10.1821 11.068 10.189 11.005 10.1784 10.9437L9.91803 9.42796L11.0192 8.35504C11.064 8.31169 11.0957 8.25664 11.1108 8.19616C11.1259 8.13567 11.1237 8.07217 11.1045 8.01286Z"
                  fill="#CCCCCC"/>
            </svg>
            <span slot="title">作品评审</span>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="right_box">
        <router-view></router-view>
      </div>
    </div>
  </el-container>
</template>

<script>
import personalCenterHeader from "@/components/personalCenterHeader.vue";
import myFooter from "@/components/myFooter.vue";

export default {
  components: {personalCenterHeader, myFooter},
  data() {
    return {
      curActive: "1-1"
    };
  },
  watch: {
    $route() {
      this.setCurActive();
    }
  },
  created() {
    this.setCurActive();
  },
  methods: {
    toList() {
      this.api.getJudges({
        pageSize: 0
      }).then(res => {
        if (res.error["err_code"] !== 0) return;
        if (res.obj.total > 0) {
          this.$router.push({
            path: "/personal_center/judge/opus/list"
          });
        } else {
          this.$message.info("您不是评委身份，无法查看");
        }
      });
    },
    //设置选中菜单
    setCurActive() {
      let path = this.$route.path;
      let active = "";
      if (path.indexOf("/personal_center/judge/certificate") !== -1) {
        active = "/personal_center/judge/certificate";
      } else if (path.indexOf("/personal_center/judge/opus/list") !== -1) {
        active = "/personal_center/judge/opus/list";
      } else if (path.indexOf("/personal_center/judge/opus/detail") !== -1) {
        active = "/personal_center/judge/opus/list";
      }
      this.curActive = active;
    }
  }
};
</script>

<style lang="scss">
@import "../index.scss";
</style>
